module.exports = __webpack_public_path__ + "img/my-qr-code-icon.cc03abff.svg";